export default __webpack_public_path__ + "static/media/1698.ffbe80f8.png";